import { render, staticRenderFns } from "./gdpr-inventory.vue?vue&type=template&id=184b8b12"
import script from "./gdpr-inventory.vue?vue&type=script&lang=js"
export * from "./gdpr-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports